/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_SlaInputs */

const en_cases_settings_category_sla = /** @type {(inputs: Cases_Settings_Category_SlaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SLA target (hours)`)
};

/**
* | output |
* | --- |
* | "SLA target (hours)" |
*
* @param {Cases_Settings_Category_SlaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cases_settings_category_sla = /** @type {((inputs?: Cases_Settings_Category_SlaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_SlaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_sla(inputs)
});